import { AfterContentInit, AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ImagilityBaseResponse, VisaDetails } from 'app-models';
import { ApiServicesService } from '../services/api-services.service';
import { MatTableDataSource } from '@angular/material/table';
import { DependentProfileDataService } from '../services/dependent-profile-data.service';
import { Subject, Subscription } from 'rxjs';
import { AuthenticationService } from 'authentication';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { ReferenceLibraryService } from 'reference-library';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-expiry-alert-documents',
  templateUrl: './expiry-alert-documents.component.html',
  styleUrls: ['./expiry-alert-documents.component.scss'],
  encapsulation: ViewEncapsulation.None,
    animations: [
      trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0' })),
        state('expanded', style({ height: '*' })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],
})
export class ExpiryAlertDocumentsComponent implements OnInit, AfterContentInit, OnDestroy, AfterViewInit {
  observableSubscription$ = new Subject();
  dataSource: MatTableDataSource<any>;
  beneficiaryId;
  expandedElement: null;
  dependentIdSubscription: Subscription;
  displayedColumns: string[] = [];
  familyId;
  loadData = {Personal: []}
  selectedDoc: any = {};
  isInvalidDates = false;
  isVisible = false;
  isI94Edit = false;
  userType;
  columns = [
    { columnDef: 'toggle', header: '', columnType: 'toggleicon', customClass: '' },
    { columnDef: 'immigrationStatusCode', header: 'Visa', columnType: 'text', customClass: '' },
    { columnDef: 'petitionTypeCode', header: 'Petition', columnType: 'text', customClass: '' },
    //{ columnDef: 'companyName', header: 'Petitioner Name', columnType: 'text', customClass: '' },
    //{ columnDef: 'visaStatus', header: 'Visa Status', columnType: 'text', customClass: '' },
    { columnDef: 'noticeNo', header: 'Receipt Number', columnType: 'text', customClass: '' },
    { columnDef: 'outcomeDate', header: 'Approval Date', columnType: 'text', customClass: '' },
    { columnDef: 'validityStartDate', header: 'Validity Start', columnType: 'text', customClass: '' },
    { columnDef: 'validityEndDate', header: 'Validity End', columnType: 'text', customClass: '' },
    { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
  ];

  ngOnInit() {
    this.userType = sessionStorage.getItem('userTypeRole');
    if(this.userType == 'Beneficiary') {
      this.beneficiaryId = parseInt(sessionStorage.getItem('beneficiaryId'));
    } else {
      this.beneficiaryId =  parseInt(sessionStorage.getItem('listBeneficiaryId'));
    }
    this.getVisaDetails();
    this.getPassportDocs(this.beneficiaryId)
    this.dependentIdSubscription = this.dependentProfileDataService.dependentProfileSubject.subscribe(selectedBeneObj => {
      // console.log("$$$$ dependentId", selectedBeneObj);
      this.familyId = selectedBeneObj.dependentId;
    })
  }

  constructor(private referenceLibraryService: ReferenceLibraryService,private apiService: ApiServicesService, private toastService: ToastrService,  private authenticationService: AuthenticationService, private dependentProfileDataService: DependentProfileDataService,) {
  }

  ngAfterViewInit() {
      this.translet();
  }


  ngOnDestroy() {
    if (this.dependentIdSubscription) {
      this.dependentIdSubscription.unsubscribe();
    }
  }

  getVisaDetails() {   
    this.apiService.getVisaDetails(this.beneficiaryId, this.familyId).subscribe((response: ImagilityBaseResponse) => {
      if (response.status === 200) {
        this.dataSource = new MatTableDataSource(response.data as []);
      }
      if (response.status === 204) {
        this.dataSource = new MatTableDataSource([]);
        this.translet();
      }
    });
  }

  ngAfterContentInit() {
    this.displayedColumns = this.columns.map(c => c.columnDef);
  }

  checkInvalidDates() {
    if(this.isI94Edit) {
      return new Date(this.selectedDoc?.arrivalDate)?.valueOf() > new Date(this.selectedDoc?.i94ExpiryDate)?.valueOf(); 
    }
    return new Date(this.selectedDoc?.validityStartDate)?.valueOf() > new Date(this.selectedDoc?.validityEndDate)?.valueOf();
  }

  saveDocDates() {
    if(this.checkInvalidDates()) {
      this.toastService.error('Expiry date must be later than the issue date');
      return;
    }
    if(this.isI94Edit) {
      this.selectedDoc.validityStartDate = this.selectedDoc.arrivalDate;
      this.selectedDoc.validityEndDate = this.selectedDoc.i94ExpiryDate;
      this.selectedDoc.travelId = this.selectedDoc.id;
    }
    this.apiService.updateDocDates(this.selectedDoc?.beneficiaryId, this.selectedDoc).subscribe(
      (val:any)=> {
        this.isVisible = false;
        this.selectedDoc = {};
        this.toastService.success(val.message)
        this.translet();
      }
    )
  }

  openEditPopup(row, i94 = false, beneficiaryId?) {
    this.isI94Edit = i94;
    this.isVisible = true;
    this.selectedDoc = JSON.parse(JSON.stringify(row));
    if(i94) {
      this.selectedDoc.beneficiaryId = beneficiaryId;
      this.selectedDoc.arrivalDate = this.selectedDoc.arrivalDate ? new Date(this.selectedDoc.arrivalDate) : '';
      this.selectedDoc.i94ExpiryDate = this.selectedDoc.i94ExpiryDate ? new Date(this.selectedDoc.i94ExpiryDate) : '';
    } else {
      this.selectedDoc.validityStartDate = this.selectedDoc.validityStartDate ? new Date(this.selectedDoc.validityStartDate) : '';
      this.selectedDoc.validityEndDate = this.selectedDoc.validityEndDate ? new Date(this.selectedDoc.validityEndDate) : '';
    }
    this.translet();
  }

   translet(){
     setTimeout(() => {
      this.referenceLibraryService.transletConversion();
     }, 600);  
   }

  getPassportDocs(beneficiaryId) {
    this.apiService.getPasportDoc(beneficiaryId).subscribe(
      (val: any) => {
        this.loadData = val?.data;
          this.translet();
      }
    )
  }

  closeEditModal() {
    this.isVisible = false;
    this.selectedDoc = {};
    this.translet();
  }

}
